<ng-container class="tag-container">
	@for (computedCustomField of customFields; track computedCustomField.baseSettings.uid) {
		<p
			[hidden]="!computedCustomField.moduleSettings.canBeTag"
			class="tags-info"
			[style.font-size]="fontSize > 0 ? fontSize + 'px' : '16px'"
			[style.height]="!isMobile && customFields.length > 2 ? '20px' : 'auto'"
			[style.color]="event.styling.contentTextColor"
		>
			@if (computedCustomField.moduleSettings.canBeTag) {
				<!-- Multi-language text field -->
				@if (
					fieldHasValue(
						computedCustomField.baseSettings.type,
						computedCustomField.fieldDatas,
						currentLanguage
					)
				) {
					<span>
						{{ computedCustomField?.fieldDatas?.field.multiLanguageText?.[currentLanguage] ?? "" }}
					</span>

					<!-- Numeric field -->
					<span>
						{{ computedCustomField?.fieldDatas?.field.numeric ?? "" }}
					</span>

					<!-- URL field -->
					<a
						[style.color]="event.styling.btnBgColor"
						target="_blank"
						href="{{ computedCustomField.fieldDatas.field.text }}"
					>
						{{ computedCustomField?.fieldDatas?.field.text ?? "" }}
					</a>

					<a
						[style.color]="event.styling.btnBgColor"
						href="mailto:{{ computedCustomField.fieldDatas.field.text }}"
					>
						{{ computedCustomField?.fieldDatas?.field.text ?? "" }}
					</a>

					<!-- Phone field -->
					<span>
						{{ computedCustomField?.fieldDatas?.field.phoneNumber?.internationalNumber ?? "" }}
					</span>

					<!-- list field -->
					<span>
						{{
							getListOptionsDisplayValue(
								computedCustomField.baseSettings.uid,
								computedCustomField?.fieldDatas?.field?.list?.selectedOptions ?? []
							)?.join(", ") ?? ""
						}}
					</span>
				}
				<!-- visibility chip -->
				<!-- @if (computedCustomField.moduleSettings.canBeTag && module.options.enableUserFieldsHideAbility) {
    <span class="visibility-state">
      @if (
      isPrivateMode &&
      !SCustomFields.canShowVisibilityChipForField(
      module,
      modulesCustomsFields,
      eventUserProfile,
      myEventUser,
      computedCustomField.baseSettings.uid,
      "customFields",
      currentLanguage
      )
      ) {
      <ion-chip color="danger">{{ "labels.hidden" | translate }}</ion-chip>
      }
      @if (
      isPrivateMode &&
      SCustomFields.canShowVisibilityChipForField(
      module,
      modulesCustomsFields,
      eventUserProfile,
      myEventUser,
      computedCustomField.baseSettings.uid,
      "customFields",
      currentLanguage
      )
      ) {
      <ion-chip color="success">{{ "labels.visible" | translate }}</ion-chip>
      }
    </span>
    } -->
			}
		</p>
	}
</ng-container>
